import React from "react";

import { Input } from "antd";
import propTypes from "prop-types";

import "./styles.scss";

// const { Search } = Input;

const SearchInput = ({ icon, label, ...rest }) => {
  return (
    <Input
      size={"large"}
      prefix={icon}
      placeholder={label}
      allowClear
      {...rest}
      className="search--input--custom"
    />
  );
};

SearchInput.defaultProps = {
  icon: propTypes.node,
  label: propTypes.string,
};

SearchInput.propTypes = {
  icon: <></>,
  label: "search",
};

export default SearchInput;
